import { Checkbox } from "@legal-500/legal500-design-system";
import { Controller } from "react-hook-form";
import type { Control, FieldErrors } from "react-hook-form";
import type { FormFieldConfig } from "../../../types/uiTypes";
import styles from "../forms/GenericForm.module.css";

type CheckboxFieldProps = {
  field: FormFieldConfig & {
    onChange?: (value: string | number) => void;
  };
  control: Control<Record<string, unknown>>;
  errors: FieldErrors<Record<string, unknown>>;
};

export function CheckboxField({ field, control, errors }: CheckboxFieldProps) {
  const error = errors[field.name]?.message;
  const errorMessage = typeof error === "string" ? error : undefined;
  const errorId = `${field.name}-error`;
  const helperId = `${field.name}-helper`;
  const describedBy = errorMessage ? errorId : field.helperText ? helperId : undefined;

  return (
    <div className={styles.formField}>
      <Controller
        name={field.name}
        control={control}
        render={({ field: controllerField }) => (
          <Checkbox
            id={field.name}
            checked={!!controllerField.value}
            onChange={event => {
              const checked = event.target.checked;
              controllerField.onChange(checked);
              if (field.onChange) {
                field.onChange(checked ? 1 : 0);
              }
            }}
            onBlur={controllerField.onBlur}
            label={field.label}
            aria-invalid={!!errorMessage}
            aria-describedby={describedBy}
          />
        )}
      />
      {errorMessage && (
        <span id={errorId} className={styles.errorText} role="alert" aria-live="polite">
          {errorMessage}
        </span>
      )}
      {field.helperText && !errorMessage && (
        <span id={helperId} className={styles.helperText}>
          {field.helperText}
        </span>
      )}
    </div>
  );
}
